<div class="modal-body has-bg user-guide-modal text-center">
    <div class="login-popup-div">
        <div class="login-title" [ngStyle]="{'background-color': info?.content?.color}">
            <button type="button" class="btn-close" (click)="closeModel()" aria-label="close user guide"></button>
            <div class=" user-guide-top-login" >
                <div class="user-guide-title">
                    <img  src="assets/images/familycentral-logo.svg" alt="FamilyCentral-Logo">
                </div>
                <h3 class="text-center mt-3" >You have some pending Invite Actions.</h3>
                <p class="text-center mt-2"></p>
                <button type="button" class="primary_btn medium-blue my-3" (click)="PendingInvite()">Pending Invite</button>
            </div>
        </div>
    </div>
</div>